/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Keyword, ContentEditableDirective} from "../../../directives/content-editable.directive";
import {ActionInstance} from "../../../models/action-instance";
import {InstanceData} from "../../../models/instance-data";
import {Event} from "../../../models/event";
import {KeywordService} from "../../../services/keyword.service";
import {Component, Input, OnInit, ViewChild} from "@angular/core";

declare var $: any;

const PROP_MESSAGE = 'message';
const PROP_TO_NUMBER = 'to';
const PROP_TO_USER = "to_user";
const PROP_TO_GROUP = "to_group";

@Component({
  selector: 'app-sms-action-editor',
  templateUrl: './sms-action-editor.component.html'
})
export class SmsActionEditorComponent implements OnInit {
  
  mProperty_Message = PROP_MESSAGE;
  mProperty_ToNumber = PROP_TO_NUMBER;
  mProperty_ToUser = PROP_TO_USER;
  mProperty_ToGroup = PROP_TO_GROUP;

  @Input()
  mAction: ActionInstance;

  @Input()
  mUniqueIndex: number;

  @Input()
  set event(event: Event) {
    console.log("SMS Editor - Set Event - Old Event: '" + this.mEvent + "', New Event: '" + event + "'");
    this.mEvent = event;
    this.mAvailableKeywords = this.mKeywordService.getAvailableKeywordsForEvent(this.mEvent);
  }

  mEvent: Event;
    
  @ViewChild(ContentEditableDirective)
  mMessageContent: ContentEditableDirective;

  mMessageData: InstanceData;

  mAvailableKeywords: Keyword[];
  
  constructor(
    private mKeywordService: KeywordService
  ) { }
  

  ngOnInit(): void {
    console.log("onInit()\n\tAction: " + this.mAction.id + "/[" + this.mAction.action.id + "/" + this.mAction.action.name + "]" + "\n\tUnique Index: " + this.mUniqueIndex);

    //Get the SMS Message Data so that it can be modeled/referenced in the UI
    this.mMessageData = this.mAction == null || this.mAction.data == null? null : this.mAction.data.find(d => d.property.property == PROP_MESSAGE);
    if (this.mMessageData == null) {
      this.mMessageData = new InstanceData();
      this.mMessageData.property = this.mAction.action.properties.find(p => p.property == PROP_MESSAGE);
      this.mAction.data == null? this.mAction.data = [ this.mMessageData ] : this.mAction.data.push(this.mMessageData);
    }
  }
  
  addDataForProperty(property: string): void {
    console.log(`addDataForProperty(${property})`);
    const newData = new InstanceData();
    newData.property = this.mAction.action.properties.find(p => p.property == property);
    this.mAction.data == null? this.mAction.data = [ newData ] : this.mAction.data.push(newData);
  }
  
  removeData(data: InstanceData): void {
    console.log("removeData() - " + data);
    
    const index = this.mAction.data == null? -1 : this.mAction.data.indexOf(data);
    if (index > -1) {
      this.mAction.data.splice(index, 1);
    }
  }

  addKeyword(keyword: Keyword): boolean {
    this.mMessageContent.addKeyword(keyword);
    return false;
  }

  updateMessage(message: string): void {
    console.log("Updating Message: '" + message + "'");
    this.mMessageData.value = message;
    this.mMessageData.object_value = message;
  }

}
